import { window } from 'pro-gallery-lib';
// Promise-wrapping class
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.reject = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isPending = false;
                reject.apply(void 0, args);
            };
            _this.resolve = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isPending = false;
                resolve.apply(void 0, args);
            };
            _this.isPending = true;
        });
    }
    return Deferred;
}());
export { Deferred };
export function isGalleryInViewport(container) {
    try {
        var haveAllVariablesForViewPortCalc = !!(container &&
            Number.isInteger(container.scrollBase) &&
            Number.isInteger(container.galleryHeight) &&
            window &&
            window.document &&
            window.document.documentElement &&
            (Number.isInteger(window.document.documentElement.scrollTop) ||
                (window.document.scrollingElement &&
                    Number.isInteger(window.document.scrollingElement.scrollTop))) &&
            Number.isInteger(window.document.documentElement.offsetHeight));
        var inTopViewPort = haveAllVariablesForViewPortCalc &&
            container.scrollBase + container.galleryHeight >
                window.document.documentElement.scrollTop;
        var inBottomViewPort = haveAllVariablesForViewPortCalc &&
            container.scrollBase <
                (window.document.documentElement.scrollTop ||
                    window.document.scrollingElement.scrollTop) +
                    window.document.documentElement.offsetHeight;
        return ((inTopViewPort && inBottomViewPort) || !haveAllVariablesForViewPortCalc); // if some parameters are missing (haveAllVariablesForViewPortCalc is false) we still want the used functionality to work
    }
    catch (e) {
        console.warn('Could not calculate viewport', e);
        return true;
    }
}
//# sourceMappingURL=galleryHelpers.js.map